/** Personnalisation org BL-0675 (initLU U3129, schéma partagé U3100). */
export type U2000HideExpenseEquipmentTabsPersonalization = {
  hideExpenseAndEquipmentTabs?: boolean;
};

/** true = masquer les onglets Dépenses et Équipement sur la feuille de temps. */
export function u2000HideExpenseAndEquipmentTabs(
  personalization?: U2000HideExpenseEquipmentTabsPersonalization | null,
): boolean {
  return personalization?.hideExpenseAndEquipmentTabs === true;
}
